import { useContextState } from "../../../../../../../hooks/theme"


const useStyles = () => {
    const { colors } = useContextState()
    return {
        headerPaper: {
            display: 'flex',
            justifyContent: 'space-between',
            backgroundColor: colors.color25,
            alignItems: 'center',
            padding: '4px 8px'
        },
        leftHeader: {
            display: 'flex',
            gap: 1
        },
        headerButons: {
            display: 'flex',
            gap: '4px',
        },
        paper: {
            borderRadius: '10px',
            marginBottom: 2,
            marginLeft: '7px',
            marginRight: '7px'
        },
        acordionTitleContainer: {
            display: 'flex',
            flexDirection: 'column',
            gap: 1,
            width: '100%'
        },
        acordionTitleContainerArrow: (expanded: boolean) => ({
            display: 'flex',
            width: '100%',
            alignItems: 'start',
            paddingBottom: 1,
            borderBottom: expanded ? `1px solid ${colors.color13}` : ''
        }),
        acordionTitleDescription: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%'
        },
        arrow: {
            padding: 0,
            '& .MuiSvgIcon-root': {
                fontSize: '2rem',
            }
        },
        rotate: (expand: boolean | undefined) => ({
            transition: '200ms',
            transform: `rotate(${expand ? '180deg' : '0deg'})`,
            '& .MuiSvgIcon-root': {
                fontSize: '2rem',
            }
        }),
        chips: {
            display: 'flex',
            gap: 1
        },




        container: {
            padding: 3
        },
        setting: {
            padding: '0px'
        },
        mapLink: {
            cursor: 'pointer',
            color: 'primary.main',
            textDecoration: 'underline',
            '&:hover': {
                color: 'primary.dark',
            },
        },
        containerItem: {
            padding: 2,
            width: '100%',
        },
        add: {
            fontSize: '2rem',
            color: 'secondary.100'
        },
        alignHorizontal: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 1,
        },
        containerList: {
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            maxHeight: '400px',
            overflow: 'scroll',
            scrollbarWidth: 'none', // Firefox
            msOverflowStyle: 'none', // Internet Explorer y Edge
            '&::-webkit-scrollbar': {
                display: 'none', // Chrome, Safari y WebKit
            },
            padding: '2px'
        },
        root: {
            display: 'flex',
            flexDirection: 'column'
        }
    }
}

export { useStyles }
